import { AbstractFilterModel } from "@gipi-pages/abstract/models/abstract-filter.model";

export class NotificationTypeFilterDTO extends AbstractFilterModel {

    enabled: boolean;

}
